import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { StatAlerts } from 'app/model/redshift/stat-alerts';
import { statAlertsService } from 'app/services/seam-request/stat-alerts.service';
import { StatAlertGrid } from 'features/qa/stat-alert/stat-alert-grid';

export const StatAlertReport: React.FunctionComponent = () => {
    const [currentAlerts, setCurrentAlerts] = useState<StatAlerts[]>([]);

    useEffect(() => {
        const inflightAlertList = statAlertsService
            .listAll({
                pageSize: GeneralConstants.PAGE_SIZE_HUGE,
            })
            .subscribe(setCurrentAlerts);

        return () => {
            inflightAlertList.unsubscribe();
        };
    }, []);

    return (
        <>
            <Typography variant='h5'>Seam Stat Alerts</Typography>
            <Typography variant='body1' className='mb-2'>
                This data is backed by RedShift database, please be patient as many queries will be slow.
            </Typography>
            <StatAlertGrid
                density='compact'
                rows={currentAlerts}
                pagination
                autoPageSize
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
                processRowUpdate={(updatedRow) => {
                    // there are none editable (valid) cells (status editable columnDef param is commented out)
                    statAlertsService.updateStatus(updatedRow.id, updatedRow.status!);

                    return updatedRow;
                }}
            />
        </>
    );
};
